// import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
// import reportWebVitals from './reportWebVitals'
// MSAL
import { PublicClientApplication } from "@azure/msal-browser"
import { MsalProvider } from "@azure/msal-react"
import { msalConfig } from "./auth/authConfigMSAL"

// Imports for CometChat
// import { createRoot } from "react-dom/client"; // already in the file
import "./index.css";
// import App from "./App.tsx"; // already in the file
import {
  UIKitSettingsBuilder,
  CometChatUIKit,
} from "@cometchat/chat-uikit-react";
import { setupLocalization } from "./CometChat/utils/utils"; // removed .ts at the end
import { CometChatProvider } from "./CometChat/context/CometChatContext";

// MSAL Config
const msalInstance = new PublicClientApplication(msalConfig)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// CometChat Config
export const COMETCHAT_CONSTANTS = {
  APP_ID: process.env.REACT_APP_COMETCHAT_APP_ID || '16750978346fa435f', // Replace with your App ID
  REGION: process.env.REACT_APP_COMETCHAT_REGION || 'US', // Replace with your App Region
  AUTH_KEY: process.env.REACT_APP_COMETCHAT_AUTH_KEY || 'cd27087118afd52c776a6406585ad8d9aa201fc4', // Replace with your Auth Key or leave blank if you are authenticating using Auth Token
};

const uiKitSettings = new UIKitSettingsBuilder()
  .setAppId(COMETCHAT_CONSTANTS.APP_ID)
  .setRegion(COMETCHAT_CONSTANTS.REGION)
  .setAuthKey(COMETCHAT_CONSTANTS.AUTH_KEY)
  .subscribePresenceForAllUsers()
  .build();

CometChatUIKit.init(uiKitSettings)?.then(() => {
    setupLocalization();
    root.render(
      // <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <CometChatProvider>
          <App />
        </CometChatProvider>
      </MsalProvider>
      // </React.StrictMode>
    );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
